import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useState } from 'react';
import DownloadIcon from '../../fundamentals/icons/download-icon';
import Spinner from '../../atoms/spinner';
import Medusa from '../../../services/api';
import Button from '../../fundamentals/button';
const ExportOrders = ({ className, queryObject = {}, count, ...props }) => {
    const [isExporting, setIsExporting] = useState(false);
    const handleExport = () => {
        setIsExporting(true);
        Medusa.orders.export(queryObject)
            .then(({ data }) => {
            const { data: base64, file_name, type } = data;
            // Create blob from base64
            const binaryString = window.atob(base64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = file_name || 'orders-export.csv';
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setIsExporting(false);
        })
            .catch((error) => {
            console.error("Export failed:", error);
            setIsExporting(false);
        });
    };
    return (_jsx(Button, { size: "small", variant: "outline", className: clsx('ml-2 h-[40px] border-[#B3D1CD]', className), onClick: handleExport, disabled: isExporting, ...props, children: _jsx("div", { className: "flex items-center gap-x-2", children: isExporting ? (_jsxs(_Fragment, { children: [_jsx(Spinner, { size: "small", variant: "secondary" }), _jsx("span", { children: "Exporting..." })] })) : (_jsxs(_Fragment, { children: [_jsx(DownloadIcon, { size: 16 }), _jsxs("span", { children: ["Export ", count ? `${count} ` : '', "Orders"] })] })) }) }));
};
export default ExportOrders;
//# sourceMappingURL=export-orders.js.map